<template>
  <div id="file-logs">
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <h4 class="m-0">
        File Logs
      </h4>
    </div>

    <content-spinner :show="fileLogs.loading" />

    <div class="inner-content p-3">
      <batch-upload-table
        v-if="!fileLogs.loading"
        class="table-view mb-3"
        :items="uploads.batchUpload"
        :collapse="collapse"
        :fields="batchUploadFields"
        :is-batch-upload="true"
        :options="fileLogs.batchUploadOptions"
        :field-row-colors="fieldRowColorsBatchUpload"
        :modal-name="'batch-upload'"
        @filter="filterUploadData"
        @row-clicked="batchUploadRowClicked"
      />

      <batch-upload-table
        v-if="!fileLogs.loading"
        class="table-view mt-0"
        :items="uploads.batchFileUpload"
        :collapse="collapse"
        :fields="batchFileUploadFields"
        :batch-upload-fields-length="batchUploadFields.length"
        :options="fileLogs.batchFileUploadOptions"
        :field-row-colors="fieldRowColorsBatchUploadFile"
        :modal-name="'batch-file-upload'"
        @filter="filterFileUploadData"
        @row-clicked="batchFileUploadRowClicked"
      />
    </div>

    <BatchFileUploadTableModal
      @per-page-change="onPerPageChange"
      @current-page-change="onCurrentPageChange"
      @context-change="contextChanged"
    />
  </div>
</template>

<script>
import BatchUploadTable from './components/BatchUploadTable';
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../core/components/ContentSpinner';
import filterMixin from '../../../core/mixins/filter.mixin';
import BatchFileUploadTableModal from './modals/BatchFileUploadTableModal';
import ComplexTableView from '../../../core/components/complex-table/components/ComplexTableView';

const {mapState, mapActions} = createNamespacedHelpers('monitoring');

export default {
  name: 'FileLogsView',
  components: {
    ComplexTableView,
    BatchUploadTable, ContentSpinner, BatchFileUploadTableModal,
  },
  mixins: [filterMixin],
  data() {
    return {
      uploads: {
        batchUpload: [],
        batchFileUpload: [],
      },
      collapse: {
        batchUpload: true,
        batchFileUpload: true,
      },
      batchFiles: [],
      batchUploadFields: [
        {key: 'BatchUploadId', label: 'Upload ID', dataTypeName: 'wholeNumber'},
        {key: 'BatchName', label: 'Name', dataTypeName: 'text'},
        {key: 'BatchUploadWarnings', label: ' Warnings', dataTypeName: 'text'},
        {key: 'BatchUploadErrors', label: ' Errors', dataTypeName: 'text', class: 'th-errors'},
        {key: 'StartDate', label: 'Start Date', dataTypeName: 'dateTime'},
        {key: 'EndDate', label: 'End Date', dataTypeName: 'dateTime'},
        {key: 'BatchUploadStatusName', label: 'Status', dataTypeName: 'text', capitalize: true},
        {key: 'SuccessFileCount', label: 'Success File Count', dataTypeName: 'wholeNumber'},
        {key: 'FailedFileCount', label: 'Failed File Count', dataTypeName: 'wholeNumber'},
      ],
      batchFileUploadFields: [
        {key: 'BatchFileUploadId', label: 'ID', dataTypeName: 'wholeNumber'},
        {key: 'BatchUploadId', label: 'Upload ID', dataTypeName: 'wholeNumber'},
        {key: 'BatchFileUploadErrors', label: 'Errors', dataTypeName: 'text', class: 'th-errors'},
        {key: 'FileName', label: 'File Name', dataTypeName: 'text'},
        {key: 'BatchFileStatusName', label: 'Status', dataTypeName: 'text', capitalize: true},
        {key: 'StartTime', label: 'Start Time', dataTypeName: 'dateTime'},
        {key: 'EndTime', label: 'End Time', dataTypeName: 'dateTime'},
        {key: 'totalRecords', label: 'Records', dataTypeName: 'wholeNumber'},
        {key: 'recordsIgnored', label: 'Ignored', dataTypeName: 'wholeNumber'},
        {key: 'recordsInserted', label: 'Inserted', dataTypeName: 'wholeNumber'},
        {key: 'recordsRejected', label: 'Rejected', dataTypeName: 'wholeNumber'},
        {key: 'recordsUpdated', label: 'Updated', dataTypeName: 'wholeNumber'},
        {key: 'recordsUploaded', label: 'Uploaded', dataTypeName: 'wholeNumber'},
      ],
      fieldRowColorsBatchUpload: [
        {
          columnKey: 'BatchUploadStatusName',
          options: [
            {
              value: 'failure',
              class: 'text-red',
            },
            {
              value: 'success',
              class: 'text-green',
            },
          ],
        },
      ],
      fieldRowColorsBatchUploadFile: [
        {
          columnKey: 'BatchFileStatusName',
          options: [
            {
              value: 'failure',
              class: 'text-red',
            },
            {
              value: 'success',
              class: 'text-green',
            },
          ],
        },
      ],
    };
  },
  watch: {
    ['collapse.batchUpload']() {
      if (this.collapse.batchUpload) {
        if (this.batchFiles.length > 0) {
          this.uploads.batchFileUpload = this.batchFiles;
        } else {
          this.uploads.batchFileUpload = this.fileLogs.data.batchFileLogs;
        }
      }
    },
  },
  computed: {
    ...mapState(['fileLogs']),
  },
  methods: {
    ...mapActions(['getBatchData', 'showBatchFileUploadModal', 'getBatchFileUploadData', 'changePaginationData']),
    setBatchData() {
      this.uploads = {
        batchUpload: this.fileLogs.data.batchLogs,
        batchFileUpload: this.fileLogs.data.batchFileLogs,
      };
    },
    batchUploadRowClicked(e) {
      this.uploads.batchFileUpload = this.fileLogs.data.batchFileLogs.filter((el) => el.BatchUploadId === e.BatchUploadId);
    },
    batchFileUploadRowClicked(e) {
      this.showBatchFileUploadModal();
      this.getData(e.BatchFileUploadId);
    },
    async getData(id) {
      await this.getBatchFileUploadData(id);
    },
    onPerPageChange() {
      // console.log('onPerPageChange ', arguments);
    },
    onCurrentPageChange() {
      // console.log('onCurrentPageChange ', arguments);
    },
    contextChanged(context) {
      this.changePaginationData({perPage: context.pagination.perPage, currentPage: context.pagination.page});
    },
    filterUploadData(e) {
      const filter = e.filter || e;
      const activeUploads = [];
      this.uploads.batchUpload = this.fileLogs.data.batchLogs.filter((upload) => {
        for (const filterFieldName in filter) {
          if (!filter.hasOwnProperty(filterFieldName)) {
            continue;
          }
          const field = this.batchUploadFields.find((f) => f.key === filterFieldName);
          if (field.dataTypeName === this.fieldValues.text && !this.textFilter(filter[filterFieldName], upload[filterFieldName])) {
            return false;
          } else if ([this.fieldValues.wholeNumber, this.fieldValues.decimalNumber, this.fieldValues.floatNumber].includes(field.dataTypeName) && !this.numberFilter(filter[filterFieldName], upload[filterFieldName])) {
            return false;
          } else if (field.dataTypeName === this.fieldValues.dateTime && !this.dateFilter(filter[filterFieldName], upload[filterFieldName])) {
            return false;
          }
        }
        activeUploads.push(upload.BatchUploadId);
        return true;
      });
      //filterFileUploadData
      this.uploads.batchFileUpload = this.fileLogs.data.batchFileLogs.filter((fileUpload) => {
        return activeUploads.includes(fileUpload.BatchUploadId);
      });
      this.batchFiles = this.uploads.batchFileUpload;
    },
    filterFileUploadData(e) {
      const filter = e.filter || e;
      this.uploads.batchFileUpload = this.fileLogs.data.batchFileLogs.filter((fileUpload) => {
        for (const filterFieldName in filter) {
          if (!filter.hasOwnProperty(filterFieldName)) {
            continue;
          }
          const field = this.batchFileUploadFields.find((f) => f.key === filterFieldName);
          if (field.dataTypeName === this.fieldValues.text && !this.textFilter(filter[filterFieldName], fileUpload[filterFieldName])) {
            return false;
          } else if ([this.fieldValues.wholeNumber, this.fieldValues.decimalNumber, this.fieldValues.floatNumber].includes(field.dataTypeName) && !this.numberFilter(filter[filterFieldName], fileUpload[filterFieldName])) {
            return false;
          } else if (field.dataTypeName === this.fieldValues.dateTime && !this.dateFilter(filter[filterFieldName], fileUpload[filterFieldName])) {
            return false;
          }
        }
        return true;
      });
      this.batchFiles = this.uploads.batchFileUpload;
    },
    dropdownFilter(filteredField, uploadField) {
      return !(filteredField.selected !== uploadField && filteredField.selected !== 'all');
    },
  },
  async mounted() {
    await this.getBatchData();
    this.setBatchData();
  },
};
</script>

<style lang="scss">

#file-logs {

  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .action-th {
    width: 100px;
  }
  th.th-errors {
    min-width: 200px;
  }
  .inner-content {
    overflow: auto;
    flex: 1;
  }

  .card-body {
    padding: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 24px;
    overflow: hidden;
    justify-content: flex-start;
  }

  tbody {
    tr:hover {
      cursor: pointer;
      background-color: #d0d0d0;
    }
  }

}

.initial-flex {
  flex: initial !important;
}

.header-toggle {
  cursor: pointer;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

</style>
